import { useCallback } from "react"
import { useAppContext } from "../../libs/contextLib/contextLib"
import { trackTelemetry } from "../../libs/apiLib/apiLib"
import type { TelemetryEvent } from "../../types/telemetry.types"
import type { TELEMETRY_CONFIG } from "./utils"

export function useTelemetry() {
	const { user, company } = useAppContext()

	const trackEvent = useCallback(
		async (event: (typeof TELEMETRY_CONFIG)[keyof typeof TELEMETRY_CONFIG]) => {
			if (!user || !company.id) {
				console.warn("Cannot track telemetry: user or company not available")
				return
			}

			const telemetryEvent: TelemetryEvent = {
				header: {
					name: event.name,
					userId: user.id,
					organisationId: company.id,
					createdTimeUtc: new Date(),
					email: user.email,
					userAgent: navigator.userAgent,
					timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				},
				payload: { correlationId: event.correlationId },
			}

			try {
				await trackTelemetry([telemetryEvent], company.id)
			} catch (error) {
				console.error("Failed to track telemetry event:", JSON.stringify(error, null, 2))
			}
		},
		[user, company]
	)

	return {
		trackEvent,
	}
}
